import { ApiResponseObject } from "../../types";
import { UserRoles } from "./auth.constants";

export enum USER_ROLES {
  OBVEZNIK = "OBVEZNIK",
  MFIN = "MFIN",
}

export interface NestedMenuItemsNested {
  label: string;
  key: string;
  access: boolean;
}

export interface NestedMenuItems {
  children: NestedMenuItemsNested[];
  type: string;
}

export interface IMenuItems {
  label: string;
  key: string;
  icon: any;
  access?: boolean;
  children?: NestedMenuItems[];
}

export interface IRoutes {
  path: string;
  element: () => JSX.Element;
  nestedPaths?: IRoutes[];
  canAccess?: boolean;
}

export type IRoles = {
  name: UserRoles;
  aktivno: boolean;
};

export type IGetUserRolesResponse = ApiResponseObject<{
  roles: IRoles[];
  showAddDrustvo: boolean;
  selectedDrustvoId: number | null;
}>;

export enum LoginCardKey {
  INFORMACIJE_O_SISTEMU,
  AKCIZNI_PROIZVODI,
  PROPISI,
}

export interface LoginPageCard {
  slideNumber: number;
  key: LoginCardKey;
  translationKey: string;
  title: string;
  textTranslationKey: string;
}

export interface ILoginPage {
  LoginPageCards: LoginPageCard[];
}

export interface IUserCompany {
  id: number;
  pib: string;
  naziv: string;
  isSelected: boolean;
}

export type IGetUserCompaniesResponse = ApiResponseObject<IUserCompany[]>;

export type IFindCompanyByPibResponse = ApiResponseObject<{
  continueActivation: boolean;
}>;

export interface IResetPasswordPayload {
  Id: string;
  Token: string;
  Password: string;
  ConfirmPassword: string;
}
